<template>
  <div class="progress-bar">
    <div class="progress-bar-inner" :style="progressStyle"></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PProgressBar',
  props: {
    value: {
      type: Number,
      required: true,
      validator: (value) => value >= 0 && value <= 100,
    },
  },
  computed: {
    progressStyle() {
      return {
        width: `${this.value}%`,
      }
    },
  },
})
</script>

<style lang="scss">
.progress-bar {
  height: var(--spacing-2);
  background-color: var(--color-main-background);
  border-radius: 4px;
  overflow: hidden;

  width: 100%;

  @media (min-width: $breakpoint-sm) {
    width: 20rem;
  }
}

.progress-bar-inner {
  height: var(--spacing-2);
  background-color: var(--color-main);
  transition: width 0.3s ease;
}
</style>
